import { Injectable } from '@angular/core';
import { fromEvent, Observable, of, Subject, Subscription } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Injectable({ 
  providedIn: 'root' 
})
export class WindowSizeService {

  _width!: number;
  _resizeSubs!: Subscription;
  _widthSubs: Subject<number> = new Subject<number>();

  readonly sizes: Map<WidthEnum, B3ModalSize> = new Map([
    [WidthEnum.xs, 'extra-large'],
    [WidthEnum.sm, 'extra-large'],
    [WidthEnum.md, 'large'],
    [WidthEnum.lg, 'large'],
    [WidthEnum.xl, 'large'],
    [WidthEnum.xxl, 'large'],
  ]);

  constructor() {
    this._width = window.innerWidth;
    this._resizeSubs = fromEvent(window, 'resize')
      .pipe(map((w: any) => w.target!.innerWidth))
      .subscribe((width) => {
        this._widthSubs.next(width)
        this._width = +width
      });
  }

  stopListening() {
    this._resizeSubs.unsubscribe();
  }

  get isExtraSmall() {
    return this._width <= 576;
  }
  get isSmall() {
    return this._width > 576 && this._width <= 768;
  }

  get isMedium() {
    return this._width > 768 && this._width <= 992;
  }

  get isLarge() {
    return this._width > 992 && this._width <= 1200;
  }

  get isDoubleLarge() {
    return this._width > 1200 && this._width <= 1400;
  }

  get isTripleLarge() {
    return this._width > 1400;
  }

  get currentScreen(): WidthEnum {
    if (this.isExtraSmall) return WidthEnum.xs;
    if (this.isSmall) return WidthEnum.sm;
    if (this.isMedium) return WidthEnum.md;
    if (this.isLarge) return WidthEnum.lg;
    if (this.isDoubleLarge) return WidthEnum.xl;
    return WidthEnum.xxl;
  }

  get modalSize(): B3ModalSize {
    return this.sizes.get(this.currentScreen) ?? 'small';
  }
}

export type B3ModalSize = 'small' | 'large' | 'extra-large';

export enum WidthEnum {
  xs,
  sm,
  md,
  lg,
  xl,
  xxl,
}